export default __webpack_public_path__ + "static/media/fa-icon-28-light.4a585a7a.svg";